import { useNotesContext } from '../../../contexts/NotesContext';
import { NOTE_ANCHOR_TYPES } from '../../../constants/notes';
import NotesHeaderContainer from './components/NotesHeaderContainer';
import NotesList from './components/NotesList';
import DirectFarmNotes from './DirectFarmNotes';

const { SECTION, LAYER, LAYER_FEATURE } = NOTE_ANCHOR_TYPES;

// Displays the Notes for the Farm, split into Sections and Layers.
const FarmNotesList = () => {
  const { notesById } = useNotesContext();
  const notes = Object.values(notesById);

  const sectionNotes = notes.filter((n) => n.anchorType === SECTION);
  const layerAndLayerFeatureNotes = notes.filter((n) =>
    [LAYER, LAYER_FEATURE].includes(n.anchorType),
  );

  return (
    <>
      <DirectFarmNotes />

      {sectionNotes.length > 0 && (
        <>
          <NotesHeaderContainer className="pt-2">
            Section Notes
          </NotesHeaderContainer>
          <NotesList notes={sectionNotes} />
        </>
      )}

      {layerAndLayerFeatureNotes.length > 0 && (
        <>
          <NotesHeaderContainer>Layer Notes</NotesHeaderContainer>
          <NotesList notes={layerAndLayerFeatureNotes} />
        </>
      )}

      {sectionNotes.length === 0 && layerAndLayerFeatureNotes.length === 0 && (
        <div className="p-3">No notes yet for this farm.</div>
      )}
    </>
  );
};

/**
 * Displays all Notes for the farm.
 */
const FarmNotes = () => {
  return <FarmNotesList />;
};

export default FarmNotes;
